import BaseView from '../../base-view';
import Model from './model';

export default BaseView.extend({
	events: {
		'change': 'onLanguageChange'
	},

	initialize: function() {
		this.model = new Model();
	},

	render: function(e) {
		return this;
	},

	onLanguageChange: function(e) {
		this.model.set({
			languageId: e.target.value
		});

		return this.model.fetch({
			success: function(model, response) {
				if (!response) {
					return;
				}

				window.location.reload();
			}
		});
	}
});
